import React, { useState, useCallback } from 'react';
import { getPeople } from '../../api/people';
import useApi from '../../hooks/useApi';
import TopBar from '../layout/TopBar';
import PeopleList from './PeopleList';
import PersonDetail from './PersonDetail';
import SearchInput from '../shared/SearchInput';
import LoadingState from '../shared/LoadingState';
import ErrorState from '../shared/ErrorState';
import EmptyState from '../shared/EmptyState';

function PeopleView() {
  const [search, setSearch] = useState('');
  const [selectedPerson, setSelectedPerson] = useState(null);

  const apiFn = useCallback(() => {
    const params = { limit: 50, sort: 'mention_count', order: 'desc' };
    if (search) params.name = search;
    return getPeople(params);
  }, [search]);

  const { data, loading, error, refetch } = useApi(apiFn, [search]);

  return (
    <div className="view-container">
      <TopBar title="Personas" subtitle={data ? `${data.length} únicas` : ''}>
        <SearchInput value={search} onChange={setSearch} placeholder="Buscar persona..." />
      </TopBar>
      <div className="view-content">
        {loading && <LoadingState type="cards" rows={6} />}
        {error   && <ErrorState message={error} onRetry={refetch} />}
        {!loading && !error && data?.length === 0 && (
          <EmptyState icon="👥" title="Sin personas" description="No se encontraron menciones." />
        )}
        {!loading && !error && data?.length > 0 && (
          <PeopleList people={data} onPersonClick={setSelectedPerson} />
        )}
      </div>
      <PersonDetail person={selectedPerson} onClose={() => setSelectedPerson(null)} />
    </div>
  );
}

export default PeopleView;
